import { render, staticRenderFns } from "./ShowSemester.vue?vue&type=template&id=6bc85888&"
import script from "./ShowSemester.vue?vue&type=script&lang=js&"
export * from "./ShowSemester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports